export class DataElementRef {
  dataElementId: string;
}
